module.exports = __webpack_public_path__ + "static/img/is1.1c666c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/institute/pic/is1.jpg
// module id = 1MPP
// module chunks = 11